import type { IconSvgObject } from './types';

const Touch02Icon: IconSvgObject = [
  ["path", { d: "M17.25 22V20L18.2483 17.6892C18.9555 16.2125 19.9231 13.3226 18.5709 11.9618C16.4393 9.81667 13.4581 9.42404 11.7499 9.5V3.75C11.7499 2.7835 10.9664 2 9.99986 2C9.03336 2 8.24986 2.7835 8.24986 3.75V14M8.25 22V20C8.25 20 6.4219 17.9105 5.92457 17.0914C5.28229 16.0336 4.42793 14.8916 4.87367 13.6086C5.37368 12.1694 8.25 10 8.25 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Touch02Icon;
